import { DSDHeader } from "@/components/dsd-view/header";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { ChatPanel } from "./chat/chat-panel";
import { CitationPanel } from "./chat/citation-panel";
import { useChat } from "./hooks/use-chat";
import { useCitationNavigation } from "./hooks/use-citation-navigation";

export const HelpChatPage: React.FC = () => {
  const {
    messages,
    send,
    isPending,
    activeCitations,
    activeCitationIdMap,
    activeMsgId,
    switchActiveCitations,
  } = useChat();

  const { highlightedId, selectedCitationNumber, selectCitation } =
    useCitationNavigation();

  const handleCitePillClick = (citationNumber: number) => {
    selectCitation(citationNumber);
  };

  return (
    <div className="flex flex-col h-screen">
      <DSDHeader />

      {/* 2패널 레이아웃 */}
      <PanelGroup
        direction="horizontal"
        autoSaveId="cs-rag-chat-layout"
        className="flex-1 min-h-0"
      >
        {/* 좌측: 채팅 */}
        <Panel minSize={25} defaultSize={60}>
          <div className="flex h-full min-w-0 flex-col">
            <div className="shrink-0 border-b border-line-alternative bg-white px-5 py-3">
              <div className="min-w-0">
                <h1 className="headline-1-semibold text-label-normal">
                  AI 상담
                </h1>
                <p className="mt-0.5 caption-1-regular text-label-alternative">
                  가장 적절한 XBRL 태그 검색부터 금감원 편집기 사용법까지,
                  무엇이든 물어보세요
                </p>
              </div>
            </div>
            <div className="min-h-0 flex-1">
              <ChatPanel
                messages={messages}
                activeMsgId={activeMsgId}
                isPending={isPending}
                onSend={send}
                onCitePillClick={handleCitePillClick}
                onActivateMessage={switchActiveCitations}
              />
            </div>
          </div>
        </Panel>

        {/* Splitter */}
        <PanelResizeHandle className="w-2 relative shrink-0 group cursor-col-resize">
          <div className="absolute top-0 bottom-0 left-1/2 w-px -translate-x-1/2 bg-line-alternative transition-all group-hover:w-[3px] group-hover:bg-blue-600 group-data-[resize-handle-active]:w-[3px] group-data-[resize-handle-active]:bg-blue-600" />
        </PanelResizeHandle>

        {/* 우측: 출처 패널 */}
        <Panel minSize={15} defaultSize={40}>
          <div className="h-full bg-background-neutral-neutral">
            <CitationPanel
              citations={activeCitations}
              citationIdMap={activeCitationIdMap}
              selectedCitationNumber={selectedCitationNumber}
              highlightedId={highlightedId}
              onSelectCitation={selectCitation}
            />
          </div>
        </Panel>
      </PanelGroup>

      {/* 봇 버블 내부 마크다운 스타일 */}
      <style>{`
        .cs-rag-bubble > *:first-child { margin-top: 0; }
        .cs-rag-bubble > *:last-child { margin-bottom: 0; }
        .cs-rag-bubble h1, .cs-rag-bubble h2, .cs-rag-bubble h3, .cs-rag-bubble h4 {
          font-weight: 700; margin: 14px 0 6px; line-height: 1.35;
        }
        .cs-rag-bubble h1 { font-size: 17px; }
        .cs-rag-bubble h2 { font-size: 15.5px; }
        .cs-rag-bubble h3 { font-size: 14.5px; }
        .cs-rag-bubble h4 { font-size: 14px; color: var(--label-alternative); }
        .cs-rag-bubble p { margin: 6px 0; }
        .cs-rag-bubble ul, .cs-rag-bubble ol { margin: 6px 0; padding-left: 22px; }
        .cs-rag-bubble li { margin: 2px 0; }
        .cs-rag-bubble li > p { margin: 0; }
        .cs-rag-bubble hr { border: none; border-top: 1px solid var(--line-neutral); margin: 12px 0; }
        .cs-rag-bubble code {
          background: #e2e8f0; padding: 1px 5px; border-radius: 4px;
          font-size: 12.5px; font-family: ui-monospace, SFMono-Regular, monospace;
        }
        .cs-rag-bubble pre {
          background: #e8eef5; padding: 8px 10px; border-radius: 6px;
          overflow-x: auto; margin: 8px 0;
        }
        .cs-rag-bubble pre code { background: transparent; padding: 0; font-size: 12.5px; }
        .cs-rag-bubble table { border-collapse: collapse; margin: 8px 0; font-size: 13px; display: block; max-width: 100%; overflow-x: auto; }
        .cs-rag-bubble th, .cs-rag-bubble td { border: 1px solid #d1d5db; padding: 4px 8px; text-align: left; vertical-align: top; }
        .cs-rag-bubble th { background: #e2e8f0; font-weight: 600; }
        .cs-rag-bubble blockquote { border-left: 3px solid #cbd5e1; padding: 0 10px; margin: 8px 0; color: var(--label-alternative); }
      `}</style>
    </div>
  );
};
